// GQL
import { client } from '../../../../../../gql/client';

import {
  GET_CAPITOL_BY_ID,
  GET_CLASSIFICATION_BY_ID_OR_ROID,
  GET_SUB_CAPITOL_BY_ID,
} from '../../../../../../gql/queries/orders/predefinedData';
import {
  GET_CONCESSION_BY_ID,
  GET_ROAD_BY_ID,
} from '../../../../../../gql/queries/geoPositions/roads';
import { GET_TEAM_BY_ID } from '../../../../../../gql/queries/users';

// Types
import { PassDataParams } from './types';
import { laneLabel, trackLabel } from '../../../../../../utils/catalogLabels';

export const passData = async ({ formData }: PassDataParams) => {
  const id = formData.get('id');
  const roid = formData.get('roid');
  const operator = formData.get('operator');
  const registerInitDate = formData.get('registerInitDate');
  const sendStatus = formData.get('sendStatus');
  const concessionId = formData.get('concession');
  const roadId = formData.get('road');
  const classificationId = formData.get('classification');
  const capitolId = formData.get('capitol');
  const subCapitolId = formData.get('subCapitol');
  const teamId = formData.get('team');
  let teamData;

  const [
    {
      data: { concession },
    },
    {
      data: { road },
    },
  ] = await Promise.all([
    client.query({
      query: GET_CONCESSION_BY_ID,
      variables: {
        id: concessionId,
      },
    }),
    client.query({
      query: GET_ROAD_BY_ID,
      variables: {
        id: roadId,
      },
    }),
  ]);

  if (teamId) {
    const {
      data: { team },
    } = await client.query({
      query: GET_TEAM_BY_ID,
      variables: {
        id: teamId,
      },
    });
    teamData = team;
  }

  const [
    {
      data: { classification },
    },
    {
      data: { capitol },
    },
    {
      data: { subCapitol },
    },
  ] = await Promise.all([
    client.query({
      query: GET_CLASSIFICATION_BY_ID_OR_ROID,
      variables: {
        id: classificationId,
      },
    }),
    client.query({
      query: GET_CAPITOL_BY_ID,
      variables: {
        id: capitolId,
      },
    }),
    client.query({
      query: GET_SUB_CAPITOL_BY_ID,
      variables: {
        id: subCapitolId,
      },
    }),
  ]);

  const classificationPass = classification.name;
  const capitolPass = capitol.name;
  const subCapitolPass = subCapitol.name;

  const city = formData.get('city');
  const trackValue = formData.get('track');
  const direction = formData.get('direction');
  const margin = formData.get('margin');
  const laneValue = formData.get('lane');
  const pkInit = formData.get('pkInit');
  const pkEnd = formData.get('pkEnd');
  const description = formData.get('description');
  const notes = formData.get('notes');
  const specialTag = formData.get('specialTag');
  const campaign = formData.get('campaign');
  const changesCampaign = formData.get('changesCampaign');

  const roidParsed = () => {
    return roid?.toString().split(',');
  };

  return {
    id,
    roid: roidParsed(),
    operator,
    registerInitDate,
    sendStatus,
    concession: concession?.name,
    city,
    road: road?.name,
    track: trackLabel(trackValue as string | null),
    roadDirections: road.directions,
    direction,
    margin,
    lane: laneLabel(laneValue as string | null),
    pkInit,
    pkEnd,
    description,
    notes,
    specialTag,
    classification: classificationPass,
    capitol: capitolPass,
    subCapitol: subCapitolPass,
    team: teamData?.name,
    campaign: campaign,
    changesCampaign: JSON.parse(changesCampaign as string),
  };
};
